<app-loading-state *ngIf="!ready" message="Cargando centro…"></app-loading-state>
<convfact-center-form *ngIf="ready && contactUid" [uid]="centerUid" [contactUid]="contactUid" [showFaceFields]="showFaceFields"
  (saved)="returnToIndex()" (cancelled)="returnToIndex()"></convfact-center-form>